export default __webpack_public_path__ + "media/images/react_icons/slider_filters_black-c608de895bd7fc5f65b1b1495c865e5a.svg";